<div class="p-2 pb-20 md:p-10 md:flex overflow-x-hidden" *transloco="let t">
  <div
    class="text-quaternary max-h-[calc(var(--hMaxResize)-90px)] md:w-[calc(100%-472px)] md:overflow-y-scroll custom-scroll">
    @if(project.firstCall == false){
    <div class="text-font30px text-red-600 mb-2.5">Prenota la tua prima call selezionando uno slot dal calendario in
      basso</div>
    }
    <div class="text-font24px mb-2.5 font-medium">Dettaglio bando</div>

    <div class="text-font18px mb-1.5">Bando: <span class="opacity-50">{{notice.title}}</span></div>
    <div class="opacity-50 text-font18px mb-[15px]">{{notice.description}}</div>
    <div class="text-font18px mb-1.5">Scadenza: <span class="opacity-50">{{notice.endDate && notice.endDate !==
        '1-1-1970' ? notice.endDate: 'Fino ad esaurimento fondi'}}</span></div>
    <div class="text-font18px mb-10">Contributi: <span class="opacity-50">€ {{notice.stanziamentoIncentivo ??
        0}}</span></div>

    <div class="min-h-[262px] w-full rounded-xl bg-white mb-5 overflow-hidden"
      style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);">
      <!-- <std-calendar [weekly]="true" [translatePipe]="t"></std-calendar> -->
      <app-calendar
        (onDayClick)="currentEventSelected= {};suggestedTimeSlots = [];isEditEvent = false;dateSelect($event)"
        [currentDate]="currentDate" (currentWeek)="getNewEventsWeek($event)" [canResizeEvents]="false"
        [arrayEvents]="arrayEvents" (close)="currentEventSelected = {};currentEvent = {}" *ngIf="showCalendar"
        [showAllEvents]="true" [weekly]="true" [translatePipe]="t" [daysOff]="[]" (showEvent)="currentEventSelected= {};isEditEvent = false;
        currentEventSelected = $event;
        currentEvent = $event;
        manageElementsEvent($event)
      ">
        <div customModal class="size-full p-5 bg-white w-full h-full min-w-[600px] max-w-[650px]">
          <div class="w-full flex justify-between items-center">
            <div class="w-full h-full flex gap-2 items-center">
              <div class="w-[6px] h-[44px] bg-[#D9D9D9]"></div>
              <div class="flex flex-col items-start justify-center">
                <div class="text-font16px text-[#102A35] font-medium leading-[19.2px]">
                  {{ getEventTime(currentEventSelected.startDate) }}
                </div>
                <div class="text-font20px font-medium text-[#102A35] leading-6">
                  {{ currentEventSelected.name }}
                </div>
              </div>
            </div>
          </div>
          @if(currentEventSelected?.isSlot){<div
            class="w-full h-full flex flex-col items-start justify-start gap-5 mt-5">
            <div class="w-full h-full flex flex-col gap-2 items-start justify-start">
              <div class="text-base font-semibold leading-[19.2px] text-[#102A35]">
                Descrizione
              </div>
              <div class="text-sm font-medium leading-[16.8px] text-[#102A35]">
                Prima call esplicativa della durata di 30 minuti
              </div>
            </div>
          </div>}
          <div class="mt-10 w-full flex place-content-center" *transloco="let t">
            @if(!currentEventSelected?.isSlot){ <std-button class="w-[32%]" *ngIf="currentEventSelected?.completeEvent"
              (click)="modalDelete = true; refreshCalendar()" size="sm"
              buttonClass="bg-red-500 text-white hover:bg-red-500 active:bg-red-500 focus:bg-red-500">{{
              t("modal.delete") }}</std-button>
            <std-button class="w-[32%] mx-[2%]" (click)="
              isEditEvent = true; showModalEvent = true; refreshCalendar()
            " size="sm">Modifica</std-button>}
            @if(currentEventSelected?.isSlot){
            <std-button class="w-[32%] mx-[2%] !cursor-pointer" (click)="
             reserveFirstCall()
            " size="sm">Prenota</std-button>
            }
          </div>
        </div>
      </app-calendar>
    </div>
    <div class="h-[200px] w-full rounded-xl bg-white mb-5 p-[15px]"
      style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);">
      <div class="text-quaternary text-font22px font-medium">Allegati</div>
      <div
        class="mt-[10px] flex flex-wrap overflow-y-scroll gap-2.5 gap-y-2.5 place-content-start custom-scroll h-[140px]">
        @for (file of files; track $index) {
        <div class="mb-2.5 h-[60px] gap-2.5 w-[calc(50%-5px)] rounded-xl flex bg-white items-center px-2.5"
          style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);">
          <div
            class="size-10 rounded-md text-font12px opacity-50 font-medium border-primary border-[1px] flex items-center place-content-center uppercase">
            {{file?.ex}}
          </div>
          <div class="opacity-50">
            <div class="text-font14px">{{file?.name}}</div>
            <div class="text-font10px">{{file?.w}}</div>
          </div>
          <svg (click)="downloadDocument(file,'notice-documents')" class="ml-auto mr-2 cursor-pointer" width="24"
            height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 21.75C17.3845 21.75 21.75 17.3845 21.75 12C21.75 6.61547 17.3845 2.25 12 2.25C6.61547 2.25 2.25 6.61547 2.25 12C2.25 17.3845 6.61547 21.75 12 21.75ZM7.7175 11.782C7.78687 11.7121 7.86934 11.6565 7.96019 11.6184C8.05105 11.5804 8.14851 11.5606 8.24702 11.5602C8.34552 11.5598 8.44314 11.5788 8.5343 11.6162C8.62545 11.6535 8.70836 11.7084 8.77828 11.7778L11.25 14.2303V7.96875C11.25 7.76984 11.329 7.57907 11.4697 7.43842C11.6103 7.29777 11.8011 7.21875 12 7.21875C12.1989 7.21875 12.3897 7.29777 12.5303 7.43842C12.671 7.57907 12.75 7.76984 12.75 7.96875V14.2303L15.2217 11.7778C15.3631 11.6377 15.5543 11.5595 15.7533 11.5604C15.9523 11.5612 16.1429 11.6411 16.283 11.7825C16.4231 11.9239 16.5013 12.1151 16.5004 12.3141C16.4995 12.5131 16.4196 12.7036 16.2783 12.8438L12.5283 16.5652C12.3878 16.7046 12.1979 16.7828 12 16.7828C11.8021 16.7828 11.6122 16.7046 11.4717 16.5652L7.72172 12.8438C7.65164 12.7744 7.59593 12.6918 7.55778 12.6009C7.51964 12.51 7.4998 12.4124 7.49941 12.3138C7.49902 12.2151 7.51808 12.1174 7.5555 12.0262C7.59292 11.9349 7.64797 11.852 7.7175 11.782Z"
              fill="#719CFF" />
          </svg>

        </div>
        }
      </div>
    </div>
  </div>
  <div class="h-[calc(var(--hMaxResize)-170px)] mx-[30px] w-[1px] bg-quaternary"></div>
  <div class="w-[412px] rounded-[12px] pt-[15px] px-[15px] font-medium text-font22px text-quaternary">
    <div class="text-font24px flex gap-[15px] font-medium mb-9">
      <div (click)="currentTab = 0" class="cursor-pointer text-[20px]" [ngClass]="{'opacity-30': currentTab != 0 }">Chat
      </div>
      <div (click)="currentTab = 1" class="cursor-pointer text-[20px]" [ngClass]="{'opacity-30': currentTab != 1 }">Note
      </div>
      @if(role == 1 || role == 5){<div (click)="currentTab = 2" class="cursor-pointer whitespace-nowrap text-[20px]"
        [ngClass]="{'opacity-30': currentTab != 2 }">Documenti admin</div>}
      <div (click)="currentTab = 3" class="cursor-pointer text-[20px]" [ngClass]="{'opacity-30': currentTab != 3 }">
        Documenti</div>
    </div>
    @if(currentTab == 0){
    <div id="chat" class="h-[calc(var(--hMaxResize)-310px)] overflow-y-scroll custom-scroll">
      @for (message of messages; track $index) {
      <div class="mb-2.5 px-[15px] pt-2.5 pb-[15px] rounded-xl bg-white"
        style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);">
        <div class="flex gap-[6px] mb-1.5 items-center">
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="0.5" y="0.5" width="25" height="25" rx="12.5" fill="white" stroke="#719CFF" />
            <path
              d="M14.796 8.51396C14.3399 8.02154 13.7029 7.75037 12.9998 7.75037C12.2929 7.75037 11.6538 8.0199 11.1998 8.50927C10.7409 9.00404 10.5173 9.67646 10.5698 10.4026C10.6738 11.8351 11.7639 13.0004 12.9998 13.0004C14.2356 13.0004 15.3238 11.8353 15.4295 10.403C15.4827 9.68349 15.2577 9.01248 14.796 8.51396Z"
              fill="#719CFF" />
            <path
              d="M17.1249 18.2501H8.87489C8.7669 18.2515 8.65996 18.2288 8.56185 18.1837C8.46374 18.1386 8.37691 18.0722 8.3077 17.9893C8.15536 17.8072 8.09395 17.5585 8.13942 17.307C8.33723 16.2097 8.95458 15.2879 9.92489 14.6407C10.7869 14.0663 11.8789 13.7501 12.9999 13.7501C14.1209 13.7501 15.2129 14.0665 16.0749 14.6407C17.0452 15.2876 17.6625 16.2094 17.8604 17.3068C17.9058 17.5582 17.8444 17.8069 17.6921 17.989C17.6229 18.072 17.5361 18.1384 17.438 18.1836C17.3398 18.2288 17.2329 18.2515 17.1249 18.2501Z"
              fill="#719CFF" />
          </svg>
          <div class="text-quaternary opacity-80 text-font14px">{{message?.user?.firstName + ' ' +
            message?.user?.lastName}}</div>
          <div class="ml-auto text-quaternary text-font10px opacity-50">{{message?.sendDate}}</div>
        </div>
        <div class="text-quaternary opacity-50 text-font14px">{{message.message}}</div>
      </div>
      }
    </div>
    <div class="h-[44px] mt-2.5 flex gap-2.5">
      <div class="rounded-xl h-[44px] flex w-[calc(100%-54px)] bg-transparent border-primary border-[1px]">
        <input class="bg-transparent text-font16px px-[15px] w-full" [value]="message" [(ngModel)]="message"
          placeholder="Scrivi messaggio...">
      </div>
      <svg [ngClass]="{'opacity-30': !message}" (click)="message ?  sendMessage() : null" class="cursor-pointer"
        width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="44" height="44" rx="22" fill="#1F299C" />
        <path
          d="M30.4763 13.5274C30.3485 13.3997 30.1865 13.3115 30.0098 13.2737C29.8331 13.2359 29.6492 13.2499 29.4803 13.3142L13.8541 19.2286H13.851C13.6708 19.2979 13.5164 19.4211 13.4089 19.5815C13.3014 19.7418 13.246 19.9314 13.2502 20.1244C13.2545 20.3174 13.3182 20.5043 13.4328 20.6597C13.5473 20.8152 13.707 20.9314 13.89 20.9927L13.906 20.9978L19.2693 23.288C19.3739 23.3197 19.485 23.3235 19.5916 23.2989C19.6981 23.2743 19.7963 23.2222 19.8763 23.1478L28.4842 15.1271C28.5098 15.1014 28.5403 15.0811 28.5738 15.0672C28.6073 15.0533 28.6432 15.0462 28.6795 15.0462C28.7157 15.0462 28.7517 15.0533 28.7852 15.0672C28.8187 15.0811 28.8491 15.1014 28.8748 15.1271C28.9004 15.1527 28.9208 15.1832 28.9347 15.2167C28.9485 15.2502 28.9557 15.2861 28.9557 15.3224C28.9557 15.3586 28.9485 15.3946 28.9347 15.4281C28.9208 15.4616 28.9004 15.492 28.8748 15.5177L20.8537 24.1216C20.7793 24.2017 20.7272 24.2999 20.7025 24.4064C20.6779 24.5129 20.6817 24.624 20.7135 24.7286L23.0045 30.095C23.0068 30.1028 23.0092 30.1099 23.0119 30.1173C23.1369 30.4794 23.4533 30.7349 23.8357 30.7521C23.8525 30.7521 23.8584 30.7521 23.8748 30.7521C24.0678 30.7532 24.2568 30.6961 24.417 30.5884C24.5772 30.4807 24.7013 30.3273 24.7732 30.1481L30.6869 14.5263C30.7521 14.3572 30.7668 14.1729 30.7295 13.9957C30.6921 13.8184 30.6042 13.6558 30.4763 13.5274Z"
          fill="#F1F5FF" />
      </svg>


    </div>
    }
    @if(currentTab == 1){
    <div class="h-[calc(var(--hMaxResize)-310px)] overflow-y-scroll custom-scroll">
      @for (note of notes; track $index) {
      <div class="mb-2.5 px-[15px] pt-2.5 pb-[15px] rounded-xl bg-white"
        style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);">
        <div class="flex gap-[6px] mb-1.5 items-center">
          <div class="text-quaternary opacity-80 text-font14px">{{note.title}}</div>
          <div class="ml-auto text-quaternary text-font10px opacity-50">{{note.date}}</div>
        </div>
        <div class="text-quaternary opacity-50 text-font14px">{{note.description}}</div>
      </div>
      }
    </div>
    <div class="h-[44px] mt-2.5 flex gap-2.5">
      <div class="h-[44px] flex items-center w-[calc(100%-54px)] bg-transparent pl-5">
        Aggiungi nota
      </div>
      <svg width="44" height="44" class="cursor-pointer ml-auto" (click)="showModalNote = true" viewBox="0 0 17 17"
        fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.1689 2.29175C4.58405 2.29175 1.66748 5.20832 1.66748 8.79317C1.66748 12.378 4.58405 15.2946 8.1689 15.2946C11.7537 15.2946 14.6703 12.378 14.6703 8.79317C14.6703 5.20832 11.7537 2.29175 8.1689 2.29175ZM10.6694 9.29328H8.66901V11.2937C8.66901 11.4264 8.61632 11.5536 8.52253 11.6473C8.42874 11.7411 8.30154 11.7938 8.1689 11.7938C8.03626 11.7938 7.90906 11.7411 7.81527 11.6473C7.72148 11.5536 7.66879 11.4264 7.66879 11.2937V9.29328H5.66835C5.53572 9.29328 5.40851 9.24059 5.31472 9.1468C5.22094 9.05301 5.16825 8.92581 5.16825 8.79317C5.16825 8.66053 5.22094 8.53333 5.31472 8.43954C5.40851 8.34575 5.53572 8.29306 5.66835 8.29306H7.66879V6.29262C7.66879 6.15998 7.72148 6.03278 7.81527 5.93899C7.90906 5.8452 8.03626 5.79251 8.1689 5.79251C8.30154 5.79251 8.42874 5.8452 8.52253 5.93899C8.61632 6.03278 8.66901 6.15998 8.66901 6.29262V8.29306H10.6694C10.8021 8.29306 10.9293 8.34575 11.0231 8.43954C11.1169 8.53333 11.1696 8.66053 11.1696 8.79317C11.1696 8.92581 11.1169 9.05301 11.0231 9.1468C10.9293 9.24059 10.8021 9.29328 10.6694 9.29328Z"
          fill="var(--quaternary)" />
      </svg>

    </div>
    }
    @if(currentTab == 2){<div class="h-[calc(var(--hMaxResize)-310px)] overflow-y-scroll custom-scroll">
      @for (file of filesAdmin; track $index) {
      <div class="mb-2.5 h-[60px] gap-2.5 w-full rounded-xl flex bg-white items-center px-2.5"
        style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);">
        <!-- <div
            class="size-10 rounded-md text-font12px opacity-50 font-medium border-primary border-[1px] flex items-center place-content-center uppercase">
            {{file?.ex}}
          </div> -->
        <div class="opacity-50">
          <div class="text-font14px">{{file?.name}}</div>
          <div class="text-font10px">{{file?.path}}</div>
        </div>
        <a class="ml-auto" [href]="baseUrl + '/project/'+id+'/document/'+file.id" target="_blank"><svg
            class="ml-auto mr-2 cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 21.75C17.3845 21.75 21.75 17.3845 21.75 12C21.75 6.61547 17.3845 2.25 12 2.25C6.61547 2.25 2.25 6.61547 2.25 12C2.25 17.3845 6.61547 21.75 12 21.75ZM7.7175 11.782C7.78687 11.7121 7.86934 11.6565 7.96019 11.6184C8.05105 11.5804 8.14851 11.5606 8.24702 11.5602C8.34552 11.5598 8.44314 11.5788 8.5343 11.6162C8.62545 11.6535 8.70836 11.7084 8.77828 11.7778L11.25 14.2303V7.96875C11.25 7.76984 11.329 7.57907 11.4697 7.43842C11.6103 7.29777 11.8011 7.21875 12 7.21875C12.1989 7.21875 12.3897 7.29777 12.5303 7.43842C12.671 7.57907 12.75 7.76984 12.75 7.96875V14.2303L15.2217 11.7778C15.3631 11.6377 15.5543 11.5595 15.7533 11.5604C15.9523 11.5612 16.1429 11.6411 16.283 11.7825C16.4231 11.9239 16.5013 12.1151 16.5004 12.3141C16.4995 12.5131 16.4196 12.7036 16.2783 12.8438L12.5283 16.5652C12.3878 16.7046 12.1979 16.7828 12 16.7828C11.8021 16.7828 11.6122 16.7046 11.4717 16.5652L7.72172 12.8438C7.65164 12.7744 7.59593 12.6918 7.55778 12.6009C7.51964 12.51 7.4998 12.4124 7.49941 12.3138C7.49902 12.2151 7.51808 12.1174 7.5555 12.0262C7.59292 11.9349 7.64797 11.852 7.7175 11.782Z"
              fill="#719CFF" />
          </svg></a>

      </div>
      }
    </div>}
    @if(currentTab == 3){<div class="h-[calc(var(--hMaxResize)-310px)] overflow-y-scroll custom-scroll">

      <input type="file" (change)="changeFileInput($event)" class="hidden" id="inputFilePublic">
      @for (file of filesPublic; track $index) {
      <div class="mb-2.5 h-[60px] gap-2.5 w-full rounded-xl flex bg-white items-center px-2.5"
        style="box-shadow: 2px 4px 8px 0 rgba(0, 0, 0, 0.08);">
        <div class="opacity-50">
          <div class="text-font14px">{{file?.name}}</div>
          <div class="text-font10px">{{file?.path}}</div>
        </div>
        <div class="flex gap-2 w-fit ml-auto items-center">
          <svg (click)="downloadDocument(file,'project-documents')" class="cursor-pointer" width="24" height="24"
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 21.75C17.3845 21.75 21.75 17.3845 21.75 12C21.75 6.61547 17.3845 2.25 12 2.25C6.61547 2.25 2.25 6.61547 2.25 12C2.25 17.3845 6.61547 21.75 12 21.75ZM7.7175 11.782C7.78687 11.7121 7.86934 11.6565 7.96019 11.6184C8.05105 11.5804 8.14851 11.5606 8.24702 11.5602C8.34552 11.5598 8.44314 11.5788 8.5343 11.6162C8.62545 11.6535 8.70836 11.7084 8.77828 11.7778L11.25 14.2303V7.96875C11.25 7.76984 11.329 7.57907 11.4697 7.43842C11.6103 7.29777 11.8011 7.21875 12 7.21875C12.1989 7.21875 12.3897 7.29777 12.5303 7.43842C12.671 7.57907 12.75 7.76984 12.75 7.96875V14.2303L15.2217 11.7778C15.3631 11.6377 15.5543 11.5595 15.7533 11.5604C15.9523 11.5612 16.1429 11.6411 16.283 11.7825C16.4231 11.9239 16.5013 12.1151 16.5004 12.3141C16.4995 12.5131 16.4196 12.7036 16.2783 12.8438L12.5283 16.5652C12.3878 16.7046 12.1979 16.7828 12 16.7828C11.8021 16.7828 11.6122 16.7046 11.4717 16.5652L7.72172 12.8438C7.65164 12.7744 7.59593 12.6918 7.55778 12.6009C7.51964 12.51 7.4998 12.4124 7.49941 12.3138C7.49902 12.2151 7.51808 12.1174 7.5555 12.0262C7.59292 11.9349 7.64797 11.852 7.7175 11.782Z"
              fill="#719CFF" />
          </svg>
          @if(role == 1 || role == 5){<svg (click)="documentToDelete = file" class="cursor-pointer" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.50098 3.5022L4.12611 13.5044C4.15581 14.0823 4.57621 14.5046 5.12633 14.5046H10.8776C11.4299 14.5046 11.8425 14.0823 11.8778 13.5044L12.5029 3.5022" stroke="black" stroke-width="1.00189" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.50098 3.50244H13.5034" stroke="black" stroke-width="1.00189" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M6.00147 3.50097V2.25052C6.00118 2.15191 6.02039 2.05422 6.05799 1.96306C6.09559 1.8719 6.15085 1.78908 6.22057 1.71935C6.2903 1.64963 6.37312 1.59437 6.46428 1.55677C6.55544 1.51917 6.65313 1.49996 6.75174 1.50025H9.25264C9.35125 1.49996 9.44894 1.51917 9.54009 1.55677C9.63125 1.59437 9.71408 1.64963 9.7838 1.71935C9.85353 1.78908 9.90878 1.8719 9.94639 1.96306C9.98399 2.05422 10.0032 2.15191 10.0029 2.25052V3.50097" stroke="black" stroke-width="1.00189" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.0022 5.50098V12.5025" stroke="black" stroke-width="1.00189" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.75122 5.50098L6.00128 12.5025" stroke="black" stroke-width="1.00189" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.2523 5.50098L10.0022 12.5025" stroke="black" stroke-width="1.00189" stroke-linecap="round" stroke-linejoin="round"/>
</svg>}

        </div>

      </div>
      }
      <div class="h-[44px] mt-2.5 flex gap-2.5">
        <div class="h-[44px] flex items-center w-[calc(100%-54px)] bg-transparent pl-5">
          Aggiungi Documento
        </div>
        <svg width="44" height="44" class="cursor-pointer ml-auto" (click)="clickInputFilePublic()" viewBox="0 0 17 17"
          fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.1689 2.29175C4.58405 2.29175 1.66748 5.20832 1.66748 8.79317C1.66748 12.378 4.58405 15.2946 8.1689 15.2946C11.7537 15.2946 14.6703 12.378 14.6703 8.79317C14.6703 5.20832 11.7537 2.29175 8.1689 2.29175ZM10.6694 9.29328H8.66901V11.2937C8.66901 11.4264 8.61632 11.5536 8.52253 11.6473C8.42874 11.7411 8.30154 11.7938 8.1689 11.7938C8.03626 11.7938 7.90906 11.7411 7.81527 11.6473C7.72148 11.5536 7.66879 11.4264 7.66879 11.2937V9.29328H5.66835C5.53572 9.29328 5.40851 9.24059 5.31472 9.1468C5.22094 9.05301 5.16825 8.92581 5.16825 8.79317C5.16825 8.66053 5.22094 8.53333 5.31472 8.43954C5.40851 8.34575 5.53572 8.29306 5.66835 8.29306H7.66879V6.29262C7.66879 6.15998 7.72148 6.03278 7.81527 5.93899C7.90906 5.8452 8.03626 5.79251 8.1689 5.79251C8.30154 5.79251 8.42874 5.8452 8.52253 5.93899C8.61632 6.03278 8.66901 6.15998 8.66901 6.29262V8.29306H10.6694C10.8021 8.29306 10.9293 8.34575 11.0231 8.43954C11.1169 8.53333 11.1696 8.66053 11.1696 8.79317C11.1696 8.92581 11.1169 9.05301 11.0231 9.1468C10.9293 9.24059 10.8021 9.29328 10.6694 9.29328Z"
            fill="var(--quaternary)" />
        </svg>

      </div>
    </div>}
  </div>
  <std-modal [show]="showModalNote" (close)="showModalNote = false" [closeOnOutside]="false">
    <div header class="text-font18px text-Swhite">Crea nota</div>
    <div content>
      <std-input labelPosition="top" customInputClass="custom-input" customLabel="label-input" [label]="'Titolo'"
        [placeholder]="'Inserisci titolo'" customContainerlass="mb-8" [(ngModel)]="newNote.title"
        [value]="newNote.title" id="email-login" type="email">
      </std-input>
      <std-input labelPosition="top" customInputClass="custom-area" customLabel="label-input" [label]="'Testo'"
        [placeholder]="'Inserisci testo'" customContainerlass="mb-8" [(ngModel)]="newNote.description"
        [value]="newNote.description" id="email-login" type="textarea">
      </std-input>
      <std-button (click)="createNote()" id="button-login" size="sm"
        buttonClass="bg-quaternary rounded-full place-content-center font-medium mx-auto text-font22px !w-[262px] !h-[60px]">Conferma</std-button>
    </div>
  </std-modal>
  <std-modal [show]="documentToDelete ? true:false" (close)="documentToDelete = null" [closeOnOutside]="false">
    <div header class="text-font18px text-Swhite">Elimina documento</div>
    <div content class="flex gap-5">
      <std-button (click)="documentToDelete = null" id="button-login" size="sm"
        buttonClass="bg-quaternary w-[calc(50%-10px)] rounded-full place-content-center font-medium mx-auto text-font18px">Annulla</std-button>
      <std-button (click)="deleteDocument(documentToDelete);documentToDelete = null" id="button-login" size="sm"
        buttonClass="bg-quaternary w-[calc(50%-10px)] rounded-full place-content-center font-medium mx-auto text-font18px">Conferma</std-button>
    </div>
  </std-modal>

  @if(showModalEvent && project.firstCall){
  <std-modal [closeOnOutside]="false" cardClass="!max-w-[90vw] min-w-[440px]" [show]="showModalEvent"
    headerClass="bg-primary" (close)="showModalEvent = false">
    <div header class="text-white">
      {{ isEditEvent ? "Modifica evento" : "Crea evento" }}
      {{ getFormattedDate(currentDate) }}
    </div>
    <div content class="min-w-[250px] max-w-[400px] gap-4 grid max-h-[70vh] overflow-y-scroll custom-scrollbar">

      @if(isEditEvent){
      <!-- <std-select class="max-w-[400px]" typeOfFiltrableSelect="startsWith" customLabel="label-input"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" [currentValue]="{
              id: currentEventSelected.operator.id,
              fullName:
                currentEventSelected.operator.firstName +
                ' ' +
                currentEventSelected.operator.lastName
            }" label="Operatore" bindValue="id" bindLabel="fullName" (onChangeValue)="manageOperator($event)"
        customClassContaier="border-primary custom-select" placeholder="Seleziona operatore"
        [data]="myOperators"></std-select> -->
      @if(suggestedTimeSlots.length >0){
      <div class="text-title text-primary label-input">Time slot consigliati</div>
      }

      @if(suggestedTimeSlots.length > 0){
      <div class="flex overflow-x-scroll gap-x-[4%] md:gap-x-[2%] custom-scrollbar pb-2 select-none">
        @for (slot of suggestedTimeSlots; track $index) {
        <div (click)="selectSuggestedSlot(slot)"
          class="w-[22%] md:w-[15%] bg-primary text-tertiary text-small rounded-full text-center p-2 cursor-pointer">
          {{ slot }}
        </div>
        }
      </div>
      }}



      <!-- @if(changeSelectStart){
<div (click)="specialModalTimeToShow =   'time-booking-start'">
    <std-input
          customInputClass="custom-input"
          customLabel="label-input"
          class="pointer-events-none"
          [type]="'time'"
          [value]="selectStartDate?.label"
    [label]="t('timeStart')"
    [placeholder]="t('selectTime')"
          labelPosition="top"
         
        ></std-input></div>

  }  -->


      @if(!isEditEvent){
      <std-select class="max-w-[400px]" typeOfFiltrableSelect="startsWith" customLabel="label-input"
        customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar" label="Operatore" bindValue="id"
        bindLabel="fullName" (onChangeValue)="manageOperator($event)" customClassContaier="border-primary custom-select"
        placeholder="Seleziona operatore" [data]="myOperators"></std-select>
      @if(suggestedTimeSlots.length >0){
      <div class="text-title text-primary label-input">Time slot consigliati</div>
      } @if(suggestedTimeSlots.length > 0){
      <div class="flex overflow-x-scroll gap-x-[4%] md:gap-x-[2%] custom-scrollbar pb-2 select-none">
        @for (slot of suggestedTimeSlots; track $index) {
        <div (click)="selectSuggestedSlot(slot)"
          class="w-[22%] md:w-[15%] bg-primary text-tertiary text-small rounded-full text-center p-2 cursor-pointer">
          {{ slot }}
        </div>
        }
      </div>
      }
      @if(changeSelectStart){
      <div (click)="specialModalTimeToShow =   'time-booking-start'">
        <std-input customInputClass="custom-input" customLabel="label-input" class="pointer-events-none" [type]="'time'"
          [value]="selectStartDate?.label" [label]="t('timeStart')" [placeholder]="t('selectTime')"
          labelPosition="top"></std-input>
      </div>
      }
      }

      <div class="flex gap-2 w-full items-end">
        <!-- <div class="w-[88%]" *ngIf="!hideSelectClient && !userApplied">
        <std-select class="max-w-[400px]"
          (onChangeValue)="changeCustomer($event)"
          typeOfFiltrableSelect="includes"
          [filterable]="true"
          customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          label="Cliente"
          customClassContaier="border-primary custom-select"
          placeholder="Seleziona cliente"
          [data]="customers"
          [currentValue]="
            isEditEvent
              ? getMyCustomer(currentEventSelected.userId)
              : { value: null, label: t('selectUser') }
          "
        ></std-select>
      </div> -->
        <!-- <div
        class="w-[88%]"
        *ngIf="!hideSelectClient && searchedClient && userApplied"
      >
        <std-select class="max-w-[400px]"
          (onChangeValue)="changeCustomer($event)"
          typeOfFiltrableSelect="includes"
          [filterable]="true"
          customLabel="label-input"
          customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
          label="Cliente"
          customClassContaier="border-primary custom-select"
          placeholder="Seleziona cliente"
          [data]="customers"
          [currentValue]="{
            value: searchedClient.id,
            label: searchedClient.firstName + ' ' + searchedClient.lastName
          }"
        ></std-select>
      </div> -->
        <!-- currentEventSelected.userId -->
        <!-- <div class="w-[10%]">
        <std-button
          (click)="
            showModalSearchClient = true;
            userNotFound = false;
            searchedClient = null
          "
          buttonClass="bg-transparent text-title focus:bg-transparent hover:bg-transparent text-white text-medium p-0 flex items-center"
          ><svg class="size-full" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99918 1.87524C5.5191 1.87524 1.87418 5.52017 1.87418 10.0002C1.87418 14.4803 5.5191 18.1252 9.99918 18.1252C14.4793 18.1252 18.1242 14.4803 18.1242 10.0002C18.1242 5.52017 14.4793 1.87524 9.99918 1.87524ZM13.7492 10.6252H10.6242V13.7502H9.37418V10.6252H6.24918V9.37525H9.37418V6.25025H10.6242V9.37525H13.7492V10.6252Z" fill="var(--primary)"/>
</svg>
</std-button
        >
      </div> -->
      </div>



      <div class="flex gap-[4%]">
        <div class="w-[48%]">
          <std-button (click)="showModalEvent = false"
            buttonClass="bg-primary focus:bg-primary hover:bg-primary">Annulla</std-button>
        </div>
        <div class="w-[48%]">
          <std-button [disabled]="!currentEvent.userId || !selectStartDate
          " (click)="manageCalendar()"
            buttonClass="bg-primary focus:bg-primary hover:bg-primary cursor-pointer">Salva</std-button>
          <!-- 
              
        ||
            !selectStartDate ||
            !selectEndDate -->
        </div>
      </div>
    </div>
  </std-modal>}

  @if(specialModalTimeToShow === 'time-booking-start'){
  <div
    class="flex h-[calc(var(--hMaxResize)-0px)]  !w-screen bg-black !bg-opacity-35 place-content-center items-center absolute top-0 left-0 z-[10000]">
    <std-time-picker [step5Minutes]="true" [showClock]="false" [use24h]="true" [startingTime]="selectStartDate?.label"
      (changeDate)="adjustDateSelect({label:$event.formattedTime})">
      <div footer class="mt-6 place-content-center flex gap-4">
        <div class="w-full"> <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
            (click)="specialModalTimeToShow = ''" class="w-[200px]">{{ t("close") }}</std-button></div>

      </div>
    </std-time-picker>
  </div>
  }

</div>